import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  quotaWarning: {
    color: 'orange',
  },
  quotaError: {
    color: 'red',
    fontWeight: 'bold',
  },
  quotaOk: {
    color: 'green',
  },
  smallText: {
    fontSize: '0.8em',
  },
}))

const QuotaSummary = ({
  website,
}) => {

  const classes = useStyles()

  const storage = website.quota.storage.percent
  const bandwidth = website.quota.bandwidth.percent

  const getPercentClassname = useCallback(percent => {
    if(percent >= 100) return classes.quotaError
    else if(percent >= 80) return classes.quotaWarning
    else return classes.quotaOk
  }, [
    classes,
  ])

  return (
    <div className={ classes.smallText }>
      <div>storage: <span className={ getPercentClassname(storage.value) }>{ storage.title }</span></div>
      <div>bandwidth: <span className={ getPercentClassname(bandwidth.value) }>{ bandwidth.title }</span></div>
    </div>
  )
}

export default QuotaSummary
